import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import HeadlessHostedInput from './headlessHostedInput.mdx';
import CardPaymentMethodManagerValidation from './cardPaymentMethodManagerValidation.mdx';
import CardPaymentMethodManagerCreateHostedInputs from './cardPaymentMethodManagerCreateHostedInputs.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A promise that resolves to an instance of `}<inlineCode parentName="p">{`ICardPaymentMethodManager`}</inlineCode>{` or `}<inlineCode parentName="p">{`null`}</inlineCode>{`.`}</p>
    <Group summary='ICardPaymentMethodManager' mdxType="Group">
	<Item title='createHostedInputs' subtitle='() => HostedInputs' mdxType="Item">
		<CardPaymentMethodManagerCreateHostedInputs mdxType="CardPaymentMethodManagerCreateHostedInputs" />
		<Group summary='HostedInputs' mdxType="Group">
			<Item title='cardNumberInput' subtitle='IHeadlessHostedInput' mdxType="Item">
				The headless hosted input for the card number.
				<HeadlessHostedInput mdxType="HeadlessHostedInput" />
			</Item>
			<Item title='expiryInput' subtitle='IHeadlessHostedInput' mdxType="Item">
				The headless hosted input for the expiry date.
				<HeadlessHostedInput mdxType="HeadlessHostedInput" />
			</Item>
			<Item title='cvvInput' subtitle='IHeadlessHostedInput' mdxType="Item">
				The headless hosted input for the CVV.
				<HeadlessHostedInput mdxType="HeadlessHostedInput" />
			</Item>
		</Group>
	</Item>
	<Item title='setCardholderName' subtitle='(cardholderName: string) => void' mdxType="Item">
		Set the name of the cardholder.
	</Item>
	<Item title='removeHostedInputs' subtitle='() => void' mdxType="Item">
		Remove the hosted inputs.
	</Item>
	<Item title='submit' subtitle='() => Promise<void>' mdxType="Item">
		Create a payment method based on the current values after tokenization. Returns a Promise that resolves when the
		payment has been created.
	</Item>
	<Item title='validate' subtitle='() => Promise<Validation>' mdxType="Item">
		Validate the state of the payment method. Returns a Promise that resolves with a Validation object.
		<CardPaymentMethodManagerValidation mdxType="CardPaymentMethodManagerValidation" />
	</Item>
	<Item title='reset' subtitle='() => void' mdxType="Item">
		Reset the hosted fields to their initial state.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      